import { Helmet } from "react-helmet";
import {
  Autocomplete,
  Box,
  Button,
  Container,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  Menu,
  MenuItem,
  Paper,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Toolbar,
  Typography,
  Avatar,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import React, { useEffect } from "react";
import cssVariables from "../../theme/cssVariables";
import CloseIcon from "../../assets/images/plus-circle-fill.svg";
import linkedGoal from "../../assets/images/linkedGoal.svg";
import defaultProfile from "../../assets/images/defaultProfile.svg";
import arrowLinkedGoal from "../../assets/images/arrowLinkedGoal.svg";
import personalGoal from "../../assets/images/personal-goal.svg";
import { Navigate } from "react-router";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { ReactComponent as Exports } from "../../assets/images/exports.svg";
import adminService from "../../services/admin.service";
import { ReactComponent as Nodata } from "../../assets/icons/nodata.svg";

const useStyles = makeStyles({
  boxLeft: {
    width: "25%",
    "padding-bottom": "25px",
  },
  boxRight: {
    width: "75%",
    "padding-bottom": "25px",
  },
});


const DefaultForm = (props) => {
  const { icon, btn, color, open, close, data, description, name } = props
  const classes = useStyles();
  const { t } = useTranslation()
  const navigate = useNavigate();
  const [dataEmployee, setDataEmployee] = React.useState([]);
  useEffect(() => {
    if (open) {
      let dataMain = JSON.parse(JSON.stringify(data))
      for (let index = 0; index <= dataMain.criteria.length - 1; index++) {
        dataMain.criteria[index].seq = index + 1
      }
      adminService.criteriaPreview(dataMain).then(
        (response) => {
          setDataEmployee(response?.data?.employee !== undefined ? response?.data?.employee : []);
        })
        .catch((err) => {

        })
    }
  }, [open]);
  const handleCloseDialog = () => {
    close(false);
  };
  return (
    <Dialog onBackdropClick={() => { return false }} open={open} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="lg" PaperProps={{ sx: { padding: '30px 30px 15px' } }}>
      <DialogTitle id="form-add-dialog-title" fontSize={24} lineHeight="26.4px" sx={{ padding: "0 0 20px" }}>
        {t('label.preview')}
        <Box sx={{ position: "absolute", right: 0, margin: "30px 30px 0  0", top: 0 }}><img onClick={handleCloseDialog} className="clickable" src={CloseIcon} alt="browser" /></Box>
      </DialogTitle>
      <Divider />
      <Box pt="15px" display="flex" justifyContent="space-between" alignItems="center">
        <Typography fontSize={16} lineHeight="23.92px" fontWeight={400} >Showing {dataEmployee !== undefined ? dataEmployee.length : "0"} results</Typography>
        {/* <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Button sx={{ display: "flex", height: "45px", "text-transform": "none" }} variant="contained" >
            <Box sx={{ display: "flex", "align-items": "center" }}>
              <Exports />
              <Typography pl="10px" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('label.exportReport')}</Typography>
            </Box>
          </Button>
        </Box> */}
      </Box>
      <Box pt="20px">
        <Box sx={{ background: "#FAFAFA", p: "15px 20px", display: "flex", width: "100%" }}>
          <Box sx={{ whiteSpace: "nowrap", width: "13.52%" }}><Typography variant="label" fontSize={14} fontWeight={500} lineHeight="20.93px" color="#A0A0A0"> Emp.ID</Typography></Box>
          <Box sx={{ whiteSpace: "nowrap", width: "30.35%" }}><Typography variant="label" fontSize={14} fontWeight={500} lineHeight="20.93px" color="#A0A0A0"> Name</Typography></Box>
          <Box sx={{ whiteSpace: "nowrap", width: "28.10%" }}><Typography variant="label" fontSize={14} fontWeight={500} lineHeight="20.93px" color="#A0A0A0"> Position</Typography></Box>
          <Box sx={{ whiteSpace: "nowrap", width: "28.03%" }}><Typography variant="label" fontSize={14} fontWeight={500} lineHeight="20.93px" color="#A0A0A0"> Organization</Typography></Box>
        </Box>
      </Box>
      <Box sx={{ "overflow-y": "overlay" }}>
        <Box>
          {dataEmployee !== undefined && dataEmployee !== null && dataEmployee.length > 0 ?
            dataEmployee.map(item => (
              <Box>
                <Box sx={{ display: "flex", width: "100%", p: "13px 20px" }} >
                  <Box component="th" scope="row" sx={{ width: "13.52%" }}>
                    <Typography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} fontSize={16} textAlign="start" lineHeight="23.92px">{item?.code}</Typography>
                  </Box>
                  <Box component="th" scope="row" sx={{ width: "30.35%" }}>
                    <Typography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} fontSize={16} textAlign="start" lineHeight="23.92px">{item?.fullname}</Typography>
                  </Box>
                  <Box component="th" scope="row" sx={{ width: "28.10%" }}>
                    <Typography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} fontSize={16} textAlign="start" lineHeight="23.92px">{item?.position}</Typography>
                  </Box>
                  <Box component="th" scope="row" sx={{ width: "28.03%" }}>
                    <Typography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} fontSize={16} textAlign="start" lineHeight="23.92px">{item?.organization}</Typography>
                  </Box>
                </Box>
                <Divider />
              </Box>
            )) :
            <Box sx={{ "padding-top": "50px", "text-align": "center", "padding-bottom": "50px" }}>
              <Nodata />
              <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                {t('label.noData')}
              </Typography>
              {/* <Typography color="#A0A0A0" fontWeight="400" fontSize={16} lineHeight="24px" >
                {t('label.tryChangingFilter')}
              </Typography> */}
            </Box>
          }
        </Box>
      </Box>
    </Dialog>
  );
};
export default DefaultForm;
